var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ControlPosition, ZoomControlStyle, } from '@agm/core/services/google-maps-types';
import { ElementRef, EventEmitter, NgZone, OnInit, } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { config } from '../../../../../config/config';
import { BaseComponent } from '../../../../common/components/base.component';
import { ConfirmModalComponent } from '../../../../common/components/confirm.modal/confirm.modal.component';
import { ConfirmModalActions, ConfirmModalData, } from '../../../../common/components/confirm.modal/confirm.modal.provider';
import { SideFloatComponent } from '../../../../common/components/side.float/side.float.component';
import { bindFunctionsToThis, isNullOrUndefined } from '../../../../common/extensions';
import { popupCenter } from '../../../../common/extensions/browser/browser.extensions';
import { GoogleMapsService, TravelMode } from '../../../../common/services/google.maps.service';
import { ModalService } from '../../../../common/services/modal.service';
import { HubTour } from '../../../../models/hub/hub.tour';
import { ImageService } from '../../../../services/image.service';
import { VisitorApiService } from '../../../../services/visitor.api.service';
import { TravelModeStore, VisitorDataCache, VisitorTripStore } from '../../../../stores/visitor.calendar.store';
import { TripMapBottomInfoComponent } from '../../../visitor/trip/trip.map.bottom.info/trip.map.bottom.info.component';
import { AlertifyService } from '../../../../services/alertify.service';
import { MatMenuTrigger } from '@angular/material/menu';
var DirectionPlanComponent = /** @class */ (function (_super) {
    __extends(DirectionPlanComponent, _super);
    function DirectionPlanComponent(googleMapService, imageService, activatedRoute, visitorTripStore, travelModeStore, visitorApiService, modalService, formBuilder, alertify, ngZone) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.googleMapService = googleMapService;
        _this.imageService = imageService;
        _this.activatedRoute = activatedRoute;
        _this.visitorTripStore = visitorTripStore;
        _this.travelModeStore = travelModeStore;
        _this.visitorApiService = visitorApiService;
        _this.modalService = modalService;
        _this.formBuilder = formBuilder;
        _this.alertify = alertify;
        _this.ngZone = ngZone;
        _this.hubName = '';
        _this.direction = 'Getting directions...';
        _this.travelMode = TravelMode.DRIVING;
        _this.canChangeTravelMode = true;
        _this.time = '';
        _this.distance = '';
        _this.isStarted = false;
        _this.isReady = false;
        _this.searchParam = {
            searchFormGroup: FormGroup,
            searchText: '',
            searchResult: [],
            searchTimeout: null,
            isShowSearchResult: false,
            isNoResult: false,
        };
        _this.noMoreNext = false;
        _this.noMorePrevious = true;
        _this.bigStopIndex = 0;
        _this.smallStepIndex = 0;
        _this.tripPlannerMapMarker = config.tripPlannerMapMarkerNoOverlap; //ConfigService.config.tripPlannerMapMarkerNoOverlap;
        _this.hideIconMapStyler = config.google.hideMapBusinessIconStyles; //ConfigService.config.google.hideMapBusinessIconStyles;
        _this.lat = config.google.USCenter.lat; //ConfigService.config.google.USCenter.lat;
        _this.lng = config.google.USCenter.lng; //ConfigService.config.google.USCenter.lng;
        _this.zoomOptions = {
            position: ControlPosition.LEFT_BOTTOM,
            style: ZoomControlStyle.SMALL,
        };
        _this.streetViewOptions = {
            position: ControlPosition.LEFT_BOTTOM,
        };
        _this.canSetDefaultTravelMode = false;
        _this.onStart = new EventEmitter();
        _this.onEnd = new EventEmitter();
        _this.showDetail = new EventEmitter();
        _this.removeFromTrip = new EventEmitter();
        _this.mapClick = new EventEmitter();
        _this.mapReady = new EventEmitter();
        _this.enterFirstTrip = new EventEmitter();
        return _this;
    }
    DirectionPlanComponent.prototype.ngOnInit = function () {
        var _this = this;
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        bindFunctionsToThis(this);
        this.isInfoWindowsOpen = [];
        this.searchFormGroup = this.formBuilder.group({
            search: [null],
        });
        if (!!this.tour) {
            console.log(this.tour);
            if (!this.tour.defaultTravelMode) {
                this.tour.defaultTravelMode = {
                    mode: TravelMode.DRIVING,
                    canChange: true,
                };
            }
            this.travelMode = this.tour.defaultTravelMode.mode;
            this.canChangeTravelMode = this.tour.defaultTravelMode.canChange;
            this.travelModeStore.modeCommand.next(this.travelMode);
            if (!this.tour.isEventImageProcessed) {
                this.getEventsFromCache().subscribe(function (events) {
                    _this.processDefaultImages();
                    _this.drawFullRoute();
                    _this.tour.attractions.forEach(function (x) {
                        _this.isInfoWindowsOpen.push(false);
                    });
                });
            }
            else {
                this.drawFullRoute();
                this.tour.attractions.forEach(function (x) {
                    _this.isInfoWindowsOpen.push(false);
                });
            }
        }
        this.visitorTripStore.tripCommand.takeUntil(this.isDestroyed).subscribe(function (item) {
            if (!isNullOrUndefined(item.item)) {
                var targetIndex_1 = 0;
                _this.tour.attractions.forEach(function (x, index) {
                    _this.isInfoWindowsOpen[index] = false;
                    if (x.item._id === item.item._id) {
                        targetIndex_1 = index;
                        return;
                    }
                });
                setTimeout(function () {
                    _this.isInfoWindowsOpen[targetIndex_1] = true;
                });
            }
        });
        // this.travelModeStore.modeCommand.takeUntil(this.isDestroyed)
        //     .subscribe((mode: TravelMode) => {
        //         if (mode !== this.travelMode) {
        //             this.stopPlan();
        //             this.travelMode = mode;
        //             this.drawFullRoute();
        //         }
        //     });
        if (this.type === 'tour') {
            this.hideBanner();
        }
    };
    Object.defineProperty(DirectionPlanComponent.prototype, "canChangeTravelModeOnFrontend", {
        get: function () {
            return !this.isStarted && this.canChangeTravelMode && !this.canSetDefaultTravelMode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DirectionPlanComponent.prototype, "getZoom", {
        get: function () {
            if (!this.tour || !this.tour.attractions)
                return 4;
            return !this.tour.attractions.length ? 4 : this.tour.attractions.length === 1 ? 17 : 0;
        },
        enumerable: true,
        configurable: true
    });
    DirectionPlanComponent.prototype.enterFirstTripTrigger = function ($event) {
        $event.stopPropagation();
        this.enterFirstTrip.emit();
    };
    DirectionPlanComponent.prototype.showBanner = function () {
        var _this = this;
        setTimeout(function () {
            _this.banner.nativeElement.style.color = 'white';
            _this.banner.nativeElement.style.height = '40px';
        });
    };
    DirectionPlanComponent.prototype.hideBanner = function () {
        var _this = this;
        setTimeout(function () {
            _this.banner.nativeElement.style.color = 'transparent';
            _this.banner.nativeElement.style.height = '0';
        });
    };
    DirectionPlanComponent.prototype.search = function () {
        var _this = this;
        if (this.searchParam.searchTimeout) {
            clearTimeout(this.searchParam.searchTimeout);
            this.searchParam.searchTimeout = setTimeout(function () {
                _this.searchAttraction();
            }, 300);
            return;
        }
        this.searchParam.searchTimeout = setTimeout(function () {
            _this.searchAttraction();
        }, 300);
    };
    DirectionPlanComponent.prototype.onMapClick = function () {
        this.mapClick.emit();
    };
    DirectionPlanComponent.prototype.closeSideFloat = function () {
        this.sideFloat.close();
    };
    DirectionPlanComponent.prototype.popup = function () {
        var _this = this;
        this.googleMapService.getUserGPSLocation().subscribe(function (gps) {
            gps.lat = 34.087926733422;
            gps.lng = -118.24855797032;
            var addresses = [];
            for (var _i = 0, _a = _this.tour.attractions; _i < _a.length; _i++) {
                var x = _a[_i];
                if (x.item.address) {
                    var address = x.item.address.address || x.item.address;
                    addresses.push(address.replaceAll(' ', '+'));
                }
            }
            var stops = addresses.join('/');
            var navigationUrl = config.google.navigation.replace('${GPS}', gps.lat + "," + gps.lng);
            navigationUrl = navigationUrl.replace('${addresses}', stops);
            popupCenter(navigationUrl);
        }, function (error) {
            if (error) {
                alert("GPS error: " + error + ", error.code: " + error.code + ", error.message: " + error.message);
            }
            else {
                alert("GPS error, no details");
            }
            var addresses = [];
            for (var _i = 0, _a = _this.tour.attractions; _i < _a.length; _i++) {
                var x = _a[_i];
                if (x.item.address) {
                    var address = x.item.address.address || x.item.address;
                    addresses.push(address.replaceAll(' ', '+'));
                }
            }
            var stops = addresses.join('/');
            var navigationUrl = config.google.navigation.replace('${GPS}', "27.674044,-82.175407");
            navigationUrl = navigationUrl.replace('${addresses}', stops);
            popupCenter(navigationUrl);
        });
    };
    DirectionPlanComponent.prototype.fromThen = function () {
        var _this = this;
        var newWindow = window.open('', '_blank');
        setTimeout(function () {
            window.focus();
        });
        this.googleMapService
            .getUserLocation()
            .then(function () {
            var addresses = [];
            for (var _i = 0, _a = _this.tour.attractions; _i < _a.length; _i++) {
                var x = _a[_i];
                if (x.item.address) {
                    var address = x.item.address.address || x.item.address;
                    addresses.push(address.replaceAll(' ', '+'));
                }
            }
            var stops = addresses.join('/');
            var navigationUrl = config.google.navigation.replace('${GPS}', "27.674044,-82.175407");
            navigationUrl = navigationUrl.replace('${addresses}', stops);
            newWindow.focus();
            newWindow.location.href = navigationUrl;
        })
            .catch(function () {
            var addresses = [];
            for (var _i = 0, _a = _this.tour.attractions; _i < _a.length; _i++) {
                var x = _a[_i];
                if (x.item.address) {
                    var address = x.item.address.address || x.item.address;
                    addresses.push(address.replaceAll(' ', '+'));
                }
            }
            var stops = addresses.join('/');
            var navigationUrl = config.google.navigation.replace('${GPS}', "27.674044,-82.175407");
            navigationUrl = navigationUrl.replace('${addresses}', stops);
            newWindow.focus();
            newWindow.location.href = navigationUrl;
        });
    };
    DirectionPlanComponent.prototype.getGPS = function () {
        var _this = this;
        var newWindow = window.open('', '_blank');
        setTimeout(function () {
            window.focus();
        });
        navigator.geolocation.getCurrentPosition(function (position) {
            // alert(`from getGPS: ${position.coords.latitude}, ${position.coords.longitude}`);
            var lat = 34.087926733422; //position.coords.latitude;
            var lng = -118.24855797032; //position.coords.longitude;
            var addresses = [];
            for (var _i = 0, _a = _this.tour.attractions; _i < _a.length; _i++) {
                var x = _a[_i];
                if (x.item.address) {
                    var address = x.item.address.address || x.item.address;
                    addresses.push(address.replaceAll(' ', '+'));
                }
            }
            var stops = addresses.join('/');
            var navigationUrl = config.google.navigation.replace('${GPS}', "27.674044,-82.175407");
            navigationUrl = navigationUrl.replace('${addresses}', stops);
            // window.open(navigationUrl, '_blank');
            //
            // alert(navigationUrl);
            newWindow.focus();
            newWindow.location.href = navigationUrl;
        }, function (error) {
            alert('Unable to retrieve your location!' + 'ERROR(' + error.code + '): ' + error.message);
            var lat = 34.087926733422; //position.coords.latitude;
            var lng = -118.24855797032; //position.coords.longitude;
            var addresses = [];
            for (var _i = 0, _a = _this.tour.attractions; _i < _a.length; _i++) {
                var x = _a[_i];
                if (x.item.address) {
                    var address = x.item.address.address || x.item.address;
                    addresses.push(address.replaceAll(' ', '+'));
                }
            }
            var stops = addresses.join('/');
            var navigationUrl = config.google.navigation.replace('${GPS}', "27.674044,-82.175407");
            navigationUrl = navigationUrl.replace('${addresses}', stops);
            // window.open(navigationUrl, '_blank');
            //
            // alert(navigationUrl);
            newWindow.focus();
            newWindow.location.href = navigationUrl;
        });
    };
    DirectionPlanComponent.prototype.getUserLocation = function ($event) {
        var addresses = [];
        for (var _i = 0, _a = this.tour.attractions; _i < _a.length; _i++) {
            var x = _a[_i];
            if (x.item.address) {
                var address = x.item.address.address || x.item.address;
                addresses.push(address.replaceAll(' ', '+'));
            }
        }
        var stops = addresses.join('/');
        var navigationUrl = config.google.navigation.replace('${addresses}', stops);
        localStorage.setItem('gps-url', navigationUrl);
        var urlBase = window.location.href.substr(0, window.location.href.indexOf('/trips'));
        urlBase = urlBase.substr(0, urlBase.lastIndexOf('/'));
        window.open(urlBase + "/gps-redirect/", '_blank');
        $event.complete();
        this.sideFloat.close();
        // newWindow.document.write("<html><head></head><body>Please wait while we redirect you</body></html>");
        // newWindow.document.close();
        // newWindow.location.href = "";
        //
        // setTimeout(() => {
        //     window.focus();
        // });
        //
        // this.googleMapService.getUserGPSLocation().subscribe(gps => {
        //     // gps.lat = 34.087926733422;
        //     // gps.lng = -118.24855797032;
        //
        //     // let addresses = [];
        //     // for (let x of this.tour.attractions) {
        //     //     if (x.item.address) {
        //     //         let address = x.item.address.address || x.item.address;
        //     //         addresses.push(address.replaceAll(' ', '+'));
        //     //     }
        //     // }
        //     // let stops = addresses.join('/');
        //     //
        //     // let navigationUrl = config.google.navigation.replace('${GPS}', `${gps.lat},${gps.lng}`);
        //     // navigationUrl = navigationUrl.replace('${addresses}', stops);
        //
        //     newWindow.focus();
        //     newWindow.location.href = navigationUrl;
        //
        //     $event.complete();
        //     this.sideFloat.close();
        // }, (error) => {
        //
        //     // if (error) {
        //     //     alert(`GPS error: ${error}, error.code: ${error.code}, error.message: ${error.message}`);
        //     // } else {
        //     //     alert(`GPS error, no details`);
        //     // }
        //     //
        //     // let addresses = [];
        //     // for (let x of this.tour.attractions) {
        //     //     if (x.item.address) {
        //     //         let address = x.item.address.address || x.item.address;
        //     //         addresses.push(address.replaceAll(' ', '+'));
        //     //     }
        //     // }
        //     // let stops = addresses.join('/');
        //     //
        //     // let navigationUrl = config.google.navigation.replace('${GPS}', `27.674044,-82.175407`);
        //     // navigationUrl = navigationUrl.replace('${addresses}', stops);
        //     //
        //     // newWindow.focus();
        //     // newWindow.location.href = navigationUrl;
        //
        //     $event.complete();
        //     this.sideFloat.close();
        // });
    };
    DirectionPlanComponent.prototype.searchAttraction = function () {
        var _this = this;
        this.searchParam.isNoResult = false;
        //this.searchParam.isShowSearchResult = false;
        if (this.searchParam.searchText) {
            this.searchParam.searchResult = this.tour.attractions.filter(function (x) { return x.item.name.toLowerCase().indexOf(_this.searchParam.searchText.toLowerCase()) >= 0; });
            if (!this.searchParam.searchResult || !this.searchParam.searchResult.length) {
                this.searchParam.isNoResult = true;
            }
            this.searchParam.isShowSearchResult = true;
            window.addEventListener('click', this.closeSearchResult);
        }
    };
    DirectionPlanComponent.prototype.closeSearchResult = function () {
        this.searchParam.isShowSearchResult = false;
    };
    DirectionPlanComponent.prototype.ready = function () {
        this.isReady = true;
        this.mapReady.emit();
    };
    DirectionPlanComponent.prototype.notReady = function () {
        this.isReady = false;
    };
    DirectionPlanComponent.prototype.setTour = function (tour) {
        this.tour = tour;
    };
    DirectionPlanComponent.prototype.drawFullRoute = function () {
        var _this = this;
        if (!this.tour.attractions.length) {
            this.directions = null;
            this.lat = config.google.USCenter.lat;
            this.lng = config.google.USCenter.lng;
            return;
        }
        if (this.tour.attractions.length === 1) {
            this.directions = null;
            this.lat = this.tour.attractions[0].item.address.lat || this.tour.attractions[0].item.lat;
            this.lng = this.tour.attractions[0].item.address.lng || this.tour.attractions[0].item.lng;
            //this.fitBounds();
            return;
        }
        var items = [];
        this.tour.attractions.forEach(function (x) {
            items.push(x.item);
        });
        this.googleMapService.getFullRoute(items).subscribe(function (data) {
            _this.directions = data;
            _this.ready();
            _this.fitBounds();
        });
    };
    DirectionPlanComponent.prototype.drawFullRouteWithUserLocation = function (lat, lng) {
        var _this = this;
        if (!this.tour.attractions.length) {
            this.directions = null;
            this.lat = config.google.USCenter.lat;
            this.lng = config.google.USCenter.lng;
            return;
        }
        var event = {
            title: 'GPS',
            address: {
                lat: 34.076926733422,
                lng: -118.23855797032,
            },
        };
        var items = [];
        items.push(event);
        this.tour.attractions.forEach(function (x) {
            items.push(x.item);
        });
        this.googleMapService.getFullRoute(items).subscribe(function (data) {
            _this.directions = data;
            _this.ready();
            _this.fitBounds();
        });
    };
    DirectionPlanComponent.prototype.startGPSPlan = function () {
        var _this = this;
        var actions = {
            confirm: function (event) {
                _this.gpsRedirect();
                event && event.complete();
            },
            cancel: function () {
                _this.startPlan();
            },
        };
        var data = {
            confirmModalIcon: 'help',
            confirmModalTitle: '',
            confirmModalDescription: "Do you want to start this " + (this.type === 'trip' ? 'trip' : 'itinerary') + " from your current location?",
            confirmModalConfirmButtonText: 'Yes',
            confirmModalCancelButtonText: 'No',
            isAsync: true,
            color: 'primary',
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data },
            ],
            panelClass: 'ig-start-gps-modal',
        });
    };
    // public startOrStopPlan() {
    //     this.isStarted ? this.stopPlan() : this.startGPSPlan();
    // }
    DirectionPlanComponent.prototype.startOrStopPlan = function (mode) {
        if (mode) {
            this.travelMode = mode;
        }
        this.startGPSPlan();
        this.travelModeStore.modeCommand.next(this.travelMode);
    };
    DirectionPlanComponent.prototype.startPlan = function () {
        var _this = this;
        if (!this.isReady) {
            return;
        }
        this.direction = 'Getting directions...';
        this.time = '';
        this.distance = '';
        this.isStarted = true;
        this.bigStopIndex = 0;
        this.smallStepIndex = 0;
        this.onStart.emit();
        this.googleMapService.getDirection(this.tour.attractions, this.travelMode, function (response) {
            _this.ngZone.run(function () {
                _this.route = response;
                _this.noMorePrevious = true;
                _this.noMoreNext = false;
                _this.setDirectionText();
                _this.setDirectionSegment(true);
            });
            //this.smallStepIndex = 1;
        });
    };
    DirectionPlanComponent.prototype.stopPlan = function () {
        this.isStarted = false;
        this.drawFullRoute();
        this.onEnd.emit();
    };
    DirectionPlanComponent.prototype.previous = function () {
        if (this.noMorePrevious) {
            return;
        }
        var segmentChanged = false;
        if (this.smallStepIndex > 0) {
            this.smallStepIndex--;
            if (this.smallStepIndex === 0 && this.bigStopIndex === 0) {
                this.noMorePrevious = true;
            }
        }
        else {
            if (this.bigStopIndex > 0) {
                this.bigStopIndex--;
                segmentChanged = true;
                this.smallStepIndex = this.route.legs[this.bigStopIndex].steps.length - 1;
                if (this.bigStopIndex === 0 && this.smallStepIndex === 0) {
                    this.noMorePrevious = true;
                }
            }
            else {
                this.noMorePrevious = true;
                return;
            }
        }
        this.noMoreNext = false;
        this.setDirectionText();
        if (segmentChanged) {
            this.setDirectionSegment(false);
        }
    };
    DirectionPlanComponent.prototype.next = function () {
        if (this.noMoreNext) {
            return;
        }
        var segmentChanged = false;
        if (this.smallStepIndex < this.route.legs[this.bigStopIndex].steps.length - 1) {
            this.smallStepIndex++;
            if (this.bigStopIndex === this.route.legs.length - 1 &&
                this.smallStepIndex === this.route.legs[this.bigStopIndex].steps.length - 1) {
                this.noMoreNext = true;
            }
        }
        else {
            this.smallStepIndex = 0;
            if (this.bigStopIndex < this.route.legs.length - 1) {
                this.bigStopIndex++;
                segmentChanged = true;
                if (this.bigStopIndex === this.route.legs.length - 1 &&
                    this.smallStepIndex === this.route.legs[this.bigStopIndex].steps.length - 1) {
                    this.noMoreNext = true;
                }
            }
            else {
                this.noMoreNext = true;
                return;
            }
        }
        this.noMorePrevious = false;
        this.setDirectionText();
        if (segmentChanged) {
            this.setDirectionSegment(true);
        }
    };
    DirectionPlanComponent.prototype.onTravelModeChange = function () {
        var _this = this;
        if (!this.canSetDefaultTravelMode) {
            setTimeout(function () {
                _this.travelModeStore.modeCommand.next(_this.travelMode);
                _this.defaultTravelModeMenuTrigger.closeMenu();
            });
        }
    };
    DirectionPlanComponent.prototype.setDefaultTravelMode = function () {
        var _this = this;
        this.visitorApiService
            .setDefaultTravelMode(this.hubName, this.tour._id, this.travelMode, this.canChangeTravelMode)
            .subscribe(function () {
            _this.alertify.successfully('Set default travel mode');
            _this.defaultTravelModeMenuTrigger.closeMenu();
            _this.travelModeStore.modeCommand.next(_this.travelMode);
        });
    };
    DirectionPlanComponent.prototype.gpsRedirect = function () {
        var waypoints = [];
        var destination = '';
        for (var i = 0; i < this.tour.attractions.length; i++) {
            var x = this.tour.attractions[i];
            if (x.item.address) {
                var address = x.item.address.address || x.item.address;
                address = address.replaceAll(' ', '+');
                address = address.replaceAll('null,', '');
                if (i === this.tour.attractions.length - 1) {
                    destination = address;
                }
                else {
                    waypoints.push(address);
                }
            }
        }
        var stops = waypoints.join('|');
        var navigationUrl = config.google.navigationApiShort.replace('${waypoints}', stops);
        navigationUrl = navigationUrl.replace('${mode}', this.travelMode.toLowerCase());
        navigationUrl = navigationUrl.replace('${destination}', destination);
        console.log('navigationUrl', navigationUrl);
        localStorage.setItem('gps-url', navigationUrl);
        // let urlBase = window.location.href.substr(0, window.location.href.indexOf('/trips'));
        // urlBase = urlBase.substr(0, urlBase.lastIndexOf('/'));
        window.open(config.serverDomain + "gps-redirect/" + encodeURIComponent(navigationUrl), '_blank');
    };
    DirectionPlanComponent.prototype.setDirectionText = function () {
        var leg = this.route.legs[this.bigStopIndex];
        this.direction = leg.steps[this.smallStepIndex].instructions;
        this.time = leg.steps[this.smallStepIndex].duration.text;
        this.distance = leg.steps[this.smallStepIndex].distance.text;
    };
    DirectionPlanComponent.prototype.setDirectionSegment = function (isNext) {
        var start = 0;
        var stop = 0;
        if (isNext) {
            if (this.bigStopIndex >= this.tour.attractions.length - 1) {
                return;
            }
            start = this.bigStopIndex;
            stop = this.bigStopIndex + 1;
        }
        if (!isNext) {
            if (this.bigStopIndex < 0) {
                return;
            }
            start = this.bigStopIndex;
            stop = this.bigStopIndex + 1;
        }
        var startLat = this.tour.attractions[start].item.address.lat || this.tour.attractions[start].item.lat;
        var startLng = this.tour.attractions[start].item.address.lng || this.tour.attractions[start].item.lng;
        var stopLat = this.tour.attractions[stop].item.address.lat || this.tour.attractions[stop].item.lat;
        var stopLng = this.tour.attractions[stop].item.address.lng || this.tour.attractions[stop].item.lng;
        this.directions = {
            origin: {
                lat: startLat,
                lng: startLng,
            },
            destination: {
                lat: stopLat,
                lng: stopLng,
            },
            waypoints: [],
            options: {
                suppressMarkers: true,
                draggable: false,
            },
        };
    };
    DirectionPlanComponent.prototype.showInfoWindowByIndex = function (index) {
        var _this = this;
        this.hideAllSingleInfoWindow();
        this.currentIndex = index;
        if (!this.isMobile) {
            setTimeout(function () {
                _this.isInfoWindowsOpen[index] = true;
            });
        }
        else {
            setTimeout(function () {
                _this.mapBottomInfo.show();
            });
        }
    };
    DirectionPlanComponent.prototype.gotoDetails = function (item) {
        this.showDetail.emit(item);
    };
    DirectionPlanComponent.prototype.remove = function (item) {
        this.removeFromTrip.emit(item);
        this.currentIndex = null;
    };
    DirectionPlanComponent.prototype.hideAllSingleInfoWindow = function () {
        for (var i = 0; i < this.isInfoWindowsOpen.length; i++) {
            this.isInfoWindowsOpen[i] = false;
        }
    };
    DirectionPlanComponent.prototype.isNullOrUndefined = function (value) {
        return isNullOrUndefined(value);
    };
    DirectionPlanComponent.prototype.fitBounds = function () {
        var _this = this;
        var items = [];
        this.tour.attractions.forEach(function (x) {
            items.push(x.item);
        });
        this.googleMapService.fitBounds(items).subscribe(function (data) {
            _this.latLngBounds = data;
        });
    };
    DirectionPlanComponent.prototype.getEventsFromCache = function () {
        var _this = this;
        return Observable.create(function (observable) {
            var events = VisitorDataCache.events;
            if (events && events.length) {
                observable.next(events);
                observable.complete();
            }
            else {
                _this.visitorApiService
                    .getEvents(_this.hubName, {
                    limit: config.searchLimit,
                    page: 1,
                    category: 'all',
                })
                    .subscribe(function (data) {
                    VisitorDataCache.events = data;
                    observable.next(data);
                    observable.complete();
                });
            }
        });
    };
    DirectionPlanComponent.prototype.processDefaultImages = function () {
        this.tour.attractions.forEach(function (x, index) {
            // for those events use default images, need to load image from events cache
            if (!x.item.cover) {
                for (var _i = 0, _a = VisitorDataCache.events; _i < _a.length; _i++) {
                    var event_1 = _a[_i];
                    if (event_1._id === x.item._id) {
                        x.item.cover = event_1.cover;
                        break;
                    }
                }
            }
        });
    };
    return DirectionPlanComponent;
}(BaseComponent));
export { DirectionPlanComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/tours/direction.plan/direction.plan.component.ts.pre-build-optimizer.js